<template>
	<div class="">
		<h2>Статистика</h2>
		<back></back>
		<div class="game game--stat">
			<StatBody :student="user" />
		</div>
	</div>
</template>

<script>
	import StatBody from "../stats/StatBody";
	import { mapGetters } from 'vuex'
  export default {
    name: "Stats",
	  computed: {
			...mapGetters({
				user: 'user'
			})
	  },
    components: {
      StatBody
    }
  }
</script>